import ReactGA from 'react-ga';

import {ROUTE_HAS_CHANGED} from '../route/actions';

const BLACK_LIST = ['resize'];
const UNKNOWN_CATEGORY = 'UNKNOWN';

function createAnalyticsMiddleware({trackPageView, trackEvent, blackList = BLACK_LIST}) {
  return (store) => (next) => (action) => { // eslint-disable-line no-unused-vars

    const {type, payload} = action;

    switch (type) {
      case ROUTE_HAS_CHANGED: {
        const {pathname} = payload;
        trackPageView(pathname);
        break;
      }

      default: {
        const trackParts = type.split('/');

        let category = UNKNOWN_CATEGORY;
        let event = type;

        if (trackParts.length > 1) {
          category = trackParts.splice(0, 1)[0];
          event = trackParts.join('/');
        }

        if (!blackList.includes(category)) {
          if (category === UNKNOWN_CATEGORY && 'production' !== process.env.NODE_ENV) {
            console.warn(`Event tracked without category, ${type}`); // eslint-disable-line no-console
          }

          trackEvent({category, action: event});
        }
      }
    }

    return next(action);
  };
}

export const analyticsMiddleware = createAnalyticsMiddleware({
  trackPageView: (pathname) => ReactGA.pageview(pathname),
  trackEvent: (args) => ReactGA.event(args),
});



// WEBPACK FOOTER //
// ./src/state/middleware/analytics.js